import {
	Component,
	ElementRef,
	inject,
	Input,
	OnDestroy,
	OnInit,
	ViewChild,
} from '@angular/core'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { LoaderComponent } from '@ui/Components/Loader/Loader.Component'

@Component({
	selector: 'countdown',
	templateUrl: './Countdown.Component.html',
	styleUrls: ['./Countdown.Component.css'],
	imports: [LoaderComponent],
})
export class CountdownComponent implements OnInit, OnDestroy {
	@ViewChild('days', { static: true }) protected days: ElementRef

	@ViewChild('hours', { static: true }) protected hours: ElementRef

	@ViewChild('minutes', { static: true }) protected minutes: ElementRef

	@ViewChild('seconds', { static: true }) protected seconds: ElementRef

	@Input() private readonly date: Date

	protected formattedDate: string = 'Loading...'

	private interval: ReturnType<typeof setInterval>

	private readonly systemConfigService: SystemConfigService

	constructor() {
		this.systemConfigService = inject(SystemConfigService)
	}

	public ngOnInit() {
		this.formattedDate = this.date.toLocaleDateString(
			this.systemConfigService.config.locale,
			{
				weekday: 'long',
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			},
		)

		this.interval = setInterval(() => {
			const now = new Date()

			let delta = Math.abs(this.date.getTime() - now.getTime()) / 1000

			const days = Math.floor(delta / 86400)
			delta -= days * 86400

			const hours = Math.floor(delta / 3600) % 24
			delta -= hours * 3600

			const minutes = Math.floor(delta / 60) % 60
			delta -= minutes * 60

			const seconds = Math.ceil(delta % 60) - 1

			this.days.nativeElement.innerText = days
			this.hours.nativeElement.innerText = hours
			this.minutes.nativeElement.innerText = minutes
			this.seconds.nativeElement.innerText = seconds
		}, 1000)
	}

	public ngOnDestroy() {
		if (this.interval) {
			clearInterval(this.interval)
		}
	}
}
